import React from 'react';

import {StreamBankLink} from './StreamBankLink';

import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {useGetUrlToolSegment} from "../../Hooks/RouteHooks";
import {useFetchContextNode} from "../../Hooks/ContextHooks";

export const ContextNodeLink = function (props) {
    const {
        contextNode:contextNodeFromProps = null,
        contextNodeId,
        useShortName = null,
        defaultTitle = '',
        tool = null,
        children,
    } = props;

    const getUrlToolSegment = useGetUrlToolSegment();
    const contextNode = useFetchContextNode(contextNodeId, contextNodeFromProps);
    
    const link = ((contextNode?.link ?? '') + '/') + (tool ?? getUrlToolSegment());
    const title = useShortName ?
        ContextNodeService.GetShortTitle(contextNode, defaultTitle) :
        ContextNodeService.GetTitle(contextNode, defaultTitle);

    return <StreamBankLink className="sb-context-node-link" Href={link}>{children ?? title}</StreamBankLink>;
};
